export default __webpack_public_path__ + "static/media/guide_import_2.b80a934b.jpg";